// import { notify } from '@/utils/notify'
import store from '@/store'
import Vue from 'vue'
import { USER_RPT_PROCESS, USER_NOTIFICATION_RPT_CHG, USER_NOTIFICATION_BCH_CHG, USER_BCH_PROCESS } from '@/store/types'
const SockJS = require('sockjs-client/dist/sockjs.js')
const Stomp = require('stompjs')
const debugMode = process.env.VUE_APP_DEBUGMODE

let stompClient
let cntRec

export function initStompClient() {
  try {
    cntRec = 0
    if (store.state.app.wsLink) {
      const wsUrl = process.env.VUE_APP_APIURL + store.state.app.wsLink
      const headers = {
        'x-auth-token': store.state.token.token
      }

      // connectAndReconnect(wsUrl, headers, 1)
      connectAndReconnect(wsUrl, headers)
    }
  } catch (err) {
    //
    stompClient = undefined
  }
}

const connectAndReconnect = (wsUrl, headers) => {
  let sock = new SockJS(wsUrl)
  stompClient = Stomp.over(sock)
  stompClient.heartbeat.incoming = 50000
  stompClient.heartbeat.outgoing = 50000
  stompClient.debug = function (str) {
    // Switch this off in production (maybe we can have a flag for production mode)
    if (debugMode !== undefined && debugMode === true) {
      // console.log(str + '\n')
    }
  }
  stompClient.connect(headers, function (frame) {
    successfulCallback()
  }, (err) => {
    cntRec = cntRec + 1
    if (err && err.command && err.command === 'ERROR') {
      // If its error, skip retrying. Most likely token has timeout/expired
    } else {
      // https://github.com/jmesnil/stomp-websocket/issues/81
      // Error Call Back (To reconnect it after disconnecting)
      // Retry every 10 secs
      if (cntRec < 12) {
        setTimeout(() => {
          if (debugMode !== undefined && debugMode === true) {
            // console.log('Attempting to reconnect to WS')
          }
          connectAndReconnect(wsUrl, headers)
        }, 10000)
      } else {
        cntRec = 0
        console.log('stop ws to reconnect')
      }
    }
  })
}

/**
 * Called when websocket is successfully connected
 */
const successfulCallback = () => {
  // https://github.com/jhipster/generator-jhipster/issues/1370

  // Destination subscription done here
  const notificationLink = store.state.app.wsSubscribe.notification
  if (notificationLink) {
    stompClient.subscribe(notificationLink, function (message) {
      const parsedMessage = JSON.parse(message.body)
      if (parsedMessage) {
        store.dispatch('getMessagesCount')
        Vue.prototype.$toast.success('You have a new Notification')
      }
    })
  } else {
    console.error('Unable to subscribe to notification')
  }

  const reportLink = store.state.app.wsSubscribe.report
  if (reportLink) {
    stompClient.subscribe(reportLink, function (message) {
      const parsedMessage = JSON.parse(message.body)
      store.commit(USER_RPT_PROCESS, parsedMessage)
      store.commit(USER_NOTIFICATION_RPT_CHG, parsedMessage)
      store.dispatch('getReportsCount')
    })
  } else {
    console.error('Unable to subscribe to report')
  }

  // AR: 26-Sep Added for batch job return call
  const batchLink = store.state.app.wsSubscribe.batch
  if (batchLink) {
    stompClient.subscribe(batchLink, function (message) {
      const parsedMessage = JSON.parse(message.body)
      store.commit(USER_BCH_PROCESS, parsedMessage)
      store.commit(USER_NOTIFICATION_BCH_CHG, parsedMessage)
      store.dispatch('getBatchesCount')
    })
  } else {
    console.error('Unable to subscribe to batch')
  }
}

// const checkConnected = (resolve, reject, tries) => {
//   if (stompClient) {
//     if (tries < 10) {
//       if (stompClient.connected) {
//         resolve(stompClient)
//       } else {
//         setTimeout(function () {
//           console.log(tries)
//           tries++
//           checkConnected(resolve, reject, tries)
//         }, 5000)
//       }
//     }
//     if (tries >= 10) {
//       reject(new Error('Fail to init websocket (not connected)'))
//       stompClient = undefined
//     }
//   } else {
//     // By this point, stompClient cannot be null (at most not connected)
//     reject(new Error('Fail to init websocket (empty client)'))
//   }
// }

function getStompClient() {
  return new Promise((resolve, reject) => {
    if (!stompClient) {
      initStompClient()
      // checkConnected(resolve, reject, 0)
    } else {
      // checkConnected(resolve, reject, 0)
    }
  })
}

export default getStompClient
